module.exports = __webpack_public_path__ + "media/street_ambience_snippet.9085472d.mp3";